import { Check } from "lucide-react";
import { useContent, imgSrc } from "@/context/ContentContext";

const DEFAULTS = {
  badge: "Ambachtelijk maatwerk uit Rijswijk",
  title: "Meubels die generaties blijven",
  subtitle:
    "Persoonlijk meedenken van ruw idee tot definitief ontwerp. Volledig met de hand gemaakt in de werkplaats in Rijswijk, met massief hout en oog voor detail.",
  image:
    "https://images.unsplash.com/photo-1659930087003-2d64e33181f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHx3b29kd29ya2luZyUyMHdvcmtzaG9wJTIwd2FybSUyMGxpZ2h0JTIwb2FrJTIwZnVybml0dXJlfGVufDB8fHx8MTc5MDUwODQwM3ww&ixlib=rb-4.1.0&q=85",
};

const punten = [
  "Particulieren & interieurstylisten",
  "Maatwerk van ruwe plank tot afwerking",
  "Direct contact met maker René",
];

export const Hero = () => {
  const { content } = useContent();
  const hero = { ...DEFAULTS, ...(content?.hero || {}) };

  return (
  <section
    id="hero"
    data-testid="hero-section"
    className="relative min-h-[85vh] flex items-end justify-start px-6 pb-20 pt-32 bg-[#2B231D] text-white overflow-hidden"
  >
    <div className="absolute inset-0 z-0">
      <img
        src={imgSrc(hero.image)}
        alt="Sfeerbeeld van de werkplaats van De Houtregisseur"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1C1612] via-[#1C1612]/70 to-[#1C1612]/30" />
    </div>

    <img
      src="/assets/logo.jpg"
      alt="Logo De Houtregisseur — Ambacht & Vertrouwd"
      data-testid="hero-logo"
      className="absolute z-10 top-20 right-5 sm:top-24 sm:right-10 lg:right-24 w-28 sm:w-40 lg:w-56 rounded-2xl sm:rounded-3xl object-cover border-2 border-[#E6AF68]/70 shadow-2xl"
    />

    <div className="relative z-10 max-w-4xl mx-auto md:mx-0 w-full hr-reveal">
      <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/15 text-xs text-[#E6AF68] font-medium mb-6 mr-32 sm:mr-0">
        <span className="w-2 h-2 rounded-full bg-[#E6AF68]" />
        <span>{hero.badge}</span>
      </div>
      <h1 className="text-4xl sm:text-6xl md:text-7xl font-normal font-display leading-[1.08] tracking-tight mb-6 text-[#FBF9F5]">
        {hero.title}
      </h1>
      <p className="text-lg sm:text-xl text-[#D8CFC4] max-w-2xl leading-relaxed mb-10 font-normal">
        {hero.subtitle}
      </p>
      <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
        <a
          href="#contact"
          data-testid="hero-cta-aanvraag"
          className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-[#E6AF68] text-[#1C1612] font-semibold text-base hover:bg-[#F0C287] transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
        >
          Vrijblijvende Aanvraag Doen
        </a>
        <a
          href="#collectie"
          data-testid="hero-cta-werk"
          className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-white/10 hover:bg-white/15 text-white border border-white/20 text-base font-medium transition-colors backdrop-blur-sm"
        >
          Bekijk Gerealiseerd Werk
        </a>
      </div>
      <div className="mt-12 flex flex-wrap items-center gap-8 text-xs text-[#A89C8F]">
        {punten.map((p) => (
          <div key={p} className="flex items-center gap-2">
            <Check size={14} className="text-[#E6AF68]" />
            <span>{p}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};
